__turbopack_context__.v({
  "activated": "_1pr7bG_activated",
  "big": "_1pr7bG_big",
  "container": "_1pr7bG_container",
  "content": "_1pr7bG_content",
  "ghost": "_1pr7bG_ghost",
  "iconClose": "_1pr7bG_iconClose",
});
